import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=491ad1f8&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=491ad1f8&prod&lang=scss"
import style1 from "./Settings.vue?vue&type=style&index=1&id=491ad1f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ad1f8",
  null
  
)

export default component.exports